export const getMainDomain = (host: string = window.location.hostname) =>
  host.split('.').slice(-2).join('.');
